/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
import boxSelectUrl1 from "url:../assets/images/box_select_1.png";
import boxSelectUrl2 from "url:../assets/images/box_select_2.png";
import boxSelectUrl3 from "url:../assets/images/box_select_3.png";

export const canvasControlsContent = `
## Using the Canvas

The Dexter canvas is where you design your transformation pipelines. Understanding the controls will help you work efficiently.

### Navigation

- **Pan**: Click and drag on the background to move around
- **Zoom**: Use the zoom controls in the bottom right or mouse wheel
- **Fit View**: Double-click the background to fit all nodes in view

### Selecting Nodes

- **Single Select**: Click a node to select it
- **Multi-Select**: Hold Shift and click multiple nodes
- **Box Select**: Click and drag on the background while holding Shift

The screenshots below detail the process of using **box selection** to select multiple nodes on the transform engine to delete.

<img src="${boxSelectUrl1}" alt="Box selection 1" style="max-width: 900px; height: auto; display: block; margin: 24px auto;" />

<img src="${boxSelectUrl2}" alt="Box selection 2" style="max-width: 900px; height: auto; display: block; margin: 24px auto;" />

<img src="${boxSelectUrl3}" alt="Box selection 3" style="max-width: 900px; height: auto; display: block; margin: 24px auto;" />

### Moving Nodes

- Click and drag nodes to reposition them
- Snap to Grid is enabled by default for alignment
- Multiple selected nodes move together

### Creating Connections

1. Click and drag from an output handle (right side of node)
2. Drag to an input handle (left side of target node)
3. Release to create the connection

### Deleting Items

- **Delete Node**: Select node and press Delete or Backspace.  A confirmation will appear if one or more edges are connected to the nodes.
- **Delete Edge**: Click edge to select it, then press Delete or Backspace.  Alternatively, you can right-click the edge and choose "Delete edge" from the menu.
- **Clear All**: Use the Clear button in the toolbar

`;
